
import { isDev } from '../../wallet_generic/helpers/isDev';

export function getCorrectChain() {
    if (isDev()) {
        return "rinkeby";
    }
    return "mainnet";
}